// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';


// Example: AUTO

export const DataSourceSchema = t.keyof({
  AUTO: null,
  INI: null,
  FORM: null,
});

export type DataSource = t.TypeOf<typeof DataSourceSchema>;
